import { HomeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { CHIP_NAV_CELL } from "./ColorChip";

interface HomeChipProps {
  /** Подсказка — „Всички категории" / „Всички станции" */
  title: string;
  onClick: () => void;
}

/**
 * Къщичката над каталога като КЛЕТКА от мрежата с chips (CHIP_NAV_CELL):
 * иконата и „Всички" са центрирана двойка с 10px между тях (равни
 * отстояния до бордъра от двете страни). Ресет на филтъра — без активно състояние.
 */
export const HomeChip = ({ title, onClick }: HomeChipProps) => {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      title={title}
      onClick={onClick}
      // Иконата и „Всички" са една центрирана двойка с 10px между тях, така
      // че отстоянието вляво от иконата и вдясно от текста са равни
      className={`${CHIP_NAV_CELL} !flex items-center justify-center gap-2.5 px-2.5`}
    >
      <HomeOutlined className="text-base shrink-0" />
      <span className="min-w-0 truncate text-base leading-[18px] font-semibold">
        {t("ordering.allRows")}
      </span>
    </button>
  );
};
